export const TOUR_DATA = [
  {
    title: 'Custom Creation Page',
    text: 'This page can be used to manage your creations and inspect what others have made public.',
    elementId: 'customTestsPageHeader',
    // heightMultiplier: 1,
    // widthMultiplier: 0.5,
    // arrow: 'top',
  },
  {
    title: 'Search Filters',
    text: 'These options can be used to filter what is displayed and help you find what you are looking for.',
    elementId: 'customTestsFilter',
    // heightMultiplier: 0.5,
    // widthMultiplier: 1,
    arrow: 'left',
  },
  {
    title: 'Public implementations',
    text: 'Enable this option to inspect and copy what others have created and chosen to make public!',
    elementId: 'customTestsFilterPublic',
    // heightMultiplier: 0.5,
    // widthMultiplier: 1,
    arrow: 'left',
  },
  {
    title: 'Create something new!',
    text: 'Use this button to toggle a dropdown where you can select what you want to create!',
    elementId: 'createTestButton',
    // heightMultiplier: 1,
    // widthMultiplier: 0.5,
    // arrow: 'top',
  },
  {
    title: 'Help Overlay',
    text: 'You can restart this tour overlay from here.',
    elementId: 'toggleTourButton',
    // heightMultiplier: 1,
    // widthMultiplier: 0.5,
    // arrow: 'top',
  },
];
